import androidx.compose.runtime.*
import com.stevdza.san.kotlinbs.components.showToast
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.*
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.icons.fa.FaXmark
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import kotlinx.coroutines.launch
import org.example.zone360.components.CommonButton
import org.example.zone360.componentss.FieldTitleText
import org.example.zone360.componentss.FieldTitleTextNormalSimple
import org.example.zone360.theme.Palette
import org.example.zone360.theme.toSitePalette
import org.example.zone360.utils.AppGlobal
import org.example.zone360.utils.cancelSubscription
import org.example.zone360.utils.getCurrentMilliseconds
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

@Composable
fun CancelSubscriptionPopup(
    onDialogDismiss: () -> Unit,
    toastMessage: (String) -> Unit,
) {
    val scope = rememberCoroutineScope()
    val sitePalette = ColorMode.current.toSitePalette()

    var isLoading by remember { mutableStateOf(false) }
    var serverMessage by remember { mutableStateOf<String?>(null) }


    // Overlay
    Box(
        modifier = Modifier
            .position(Position.Fixed)
            .top(0.px).left(0.px)
            .width(100.percent).height(100.percent)
            .zIndex(999)
            .backgroundColor(Palette.Grey.rgbLight.copyf(alpha = 0.7f)),
        contentAlignment = Alignment.Center
    ) {

        // Center container (same style as your modals)
        Box(
            modifier = Modifier
                .width(480.px)
                .position(Position.Fixed)
                .zIndex(9)
                .top(50.percent).left(50.percent)
                .transform { translate((-50).percent, (-50).percent) }
                .borderRadius(6.px)
                .padding(30.px),
            contentAlignment = Alignment.Center
        ) {
            Box(
                Modifier
                    .color(Colors.Black)
                    .backgroundColor(sitePalette.modalBackgroundColor.rgb)
                    .maxWidth(420.px)
                    .border(
                        width = 1.px,
                        color = sitePalette.textFieldBorderColor.rgb,
                        style = LineStyle.Solid
                    )
                    .borderRadius(6.px),
                contentAlignment = Alignment.Center
            ) {
                Column(
                    modifier = Modifier.padding(topBottom = 28.px, leftRight = 28.px),
                ) {

                    // Header
                    Row(
                        modifier = Modifier.fillMaxWidth().padding(bottom = 18.px),
                        horizontalArrangement = Arrangement.SpaceBetween,
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        FieldTitleText(
                            text = "Cancel subscription",
                            marginBottom = 0.px
                        )
                        FaXmark(
                            modifier = Modifier
                                .color(sitePalette.commonButtonSupportiveTextColor.rgb)
                                .cursor(Cursor.Pointer)
                                .onClick { onDialogDismiss() },
                            size = IconSize.LG
                        )
                    }

                    // Warning content
                    FieldTitleTextNormalSimple(
                        text = "Are you sure you want to cancel your subscription?",
                        width = 100.percent,
                        marginBottom = 10.px
                    )

                    FieldTitleTextNormalSimple(
                        text = "You will keep access until the end of your current billing period. After that, your subscription will not renew.",
                        width = 100.percent,
                        marginBottom = 18.px
                    )

                    // Info box
                    Box(
                        modifier = Modifier
                            .fillMaxWidth()
                            .backgroundColor(sitePalette.primary.rgb.copyf(alpha = 0.08f))
                            .borderRadius(6.px)
                            .padding(12.px)
                            .margin(bottom = 18.px)
                    ) {
                        FieldTitleTextNormalSimple(
                            text = "Tip: You can resubscribe anytime from the plans page.",
                            width = 100.percent
                        )
                    }

                    // Error / server message
                    serverMessage?.let {
                        FieldTitleTextNormalSimple(
                            width = 100.percent,
                            textAlign = TextAlign.Center,
                            marginBottom = 12.px,
                            text = it,
                            color = sitePalette.textErrorColor.rgb
                        )
                    }

                    // Buttons
                    Row(
                        modifier = Modifier.fillMaxWidth(),
                        horizontalArrangement = Arrangement.spacedBy(10.px)
                    ) {

                        // Keep subscription button (supportive)
                        CommonButton(
                            text = "Keep subscription",
                            isLoading = false,
                            width = 50.percent,
                            onCLick = { onDialogDismiss() }
                        )

                        // Cancel subscription button (danger style)
                        CommonButton(
                            text = "Cancel subscription",
                            isLoading = isLoading,
                            width = 50.percent,
                            backgroundColor = sitePalette.textErrorColor.rgb,
                            onCLick = {
                                scope.launch {
                                    isLoading = true
                                    serverMessage = null
                                    try {
                                        val response = cancelSubscription()

                                        if (response.cancel_at_period_end) {
                                            toastMessage("Subscription cancelled successfully.")
                                            showToast("toastSuccess")

                                            val currentUser = AppGlobal.userData
                                            AppGlobal.userData = currentUser.copy(
                                                payment = currentUser.payment.copy(
                                                    subscription = currentUser.payment.subscription.copy(
                                                        cancel_at_period_end = true
                                                    )
                                                )
                                            )

                                            AppGlobal.refreshPlayerProfile = getCurrentMilliseconds().toString()
                                            AppGlobal.refreshGetProfileInPlayer = getCurrentMilliseconds().toString()

                                            onDialogDismiss()
                                        } else {
                                            serverMessage = "Unable to cancel subscription. Please try again."
                                        }
                                    } catch (t: Throwable) {
                                        serverMessage = t.message ?: "Failed to cancel subscription"
                                    } finally {
                                        isLoading = false
                                    }
                                }
                            }
                        )
                    }
                }
            }
        }
    }
}
